
import BackImg from "../../img/HomeBack.png";
import InstPng from "../../img/png.png";
import { device } from '../MainContents/Style/StyleDevice';
import styled from 'styled-components';

const MainBack = styled.div`
  background-image: url('${BackImg}');
  height: auto;
  background-size: cover;
  @media ${device.mobile}{
    height: auto;
    }
`;

const Maxdiv = styled.div`
    max-width: 1000px;
    margin: auto;
`;

const InstScope = styled.div`
    max-width: 418px;
    width: 300px;
    padding: 17px;
    margin: auto;
    margin-top: 38px;
    margin-bottom: 50px;
`;
const InstImg = styled.img`
    max-width: 37px;
    float:right;
`;


export default function Skill() {
  return (  
    <>
    <MainBack className="text-center mt-5 mb-5">

      <h3 className='pt-5 font-bold'>今だからこそ身につけたい</h3>
      <h3 className='mt-3 font-bold text-black-400 text-3xl'><span className='text-4xl'>6</span>&nbsp;つ&nbsp;の&nbsp;ス&nbsp;キ&nbsp;ル&nbsp;</h3>
      <Maxdiv className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-3 md:grid-cols-9 xl:grid-cols-9 gap-4'>
        <div className='col-span-3 p-2 rounded border-solid border border-dark-600 bg-blue-700 text-white'>
            <p className='font-bold'>自ら学ぶ力</p>
            <p>「創りたいから学びたい！」というカリキュラムを通じて、学ぶことは楽しいことだという態度を育みます。</p>
        </div>
        <div className='col-span-3 p-2 rounded border-solid border border-dark-600 bg-orange-600 text-white'>
            <p className='font-bold'>理数系科目の基礎</p>
            <p>運動やエネルギー、力や図形など理数系科目の基本的な概念を、体験を通じて学ぶ事ができ、のちの発展的な学習に役立ちます。</p>
        </div>
        <div className='col-span-3 p-2 rounded border-solid border border-dark-600 bg-green-700 text-white'>
            <p className='font-bold'>問題解決力</p>
            <p>課題を解決すために問題を小さく分解し、情報収集や試行錯誤、意思決定を繰り返し粘り強く取り組む姿勢を育みます。</p>
        </div>
      </Maxdiv>

      <Maxdiv className='mt-3 p-2 grid grid-cols-1 lg:grid-cols-3 md:grid-cols-9 xl:grid-cols-9 gap-4'>
        <div className='col-span-3  p-2 rounded border-solid border border-dark-600 bg-red-500 text-white'>
            <p className='font-bold'>論理的思考力</p>
            <p>STEMONの独自のプログラミングでは様々なものづくり課題において、物事を順序だてて考えたり、情報の構造を組み立てたりするトレーニングがたくさん含まれています。</p>
        </div>
        <div className='col-span-3 p-2 rounded border-solid border border-dark-600 bg-yellow-500 text-white'>
            <p className='font-bold'>自己肯定感</p>
            <p>プログラミングやものづくりは、すぐに反応・結果を見ることができ、うまくいった時の喜びをお子様の自信や自己肯定感を育みます。</p>
        </div>
        <div className='col-span-3 p-2 rounded border-solid border border-dark-600 bg-sky-400 text-white'>
            <p className='font-bold'>キャリア教育</p>
            <p>将来どのような仕事についてもＩＴを活用できるか否かで、仕事の成果が大きく変わります。社会で活躍するためのＩＴスキルを身につけることができます。</p>
        </div>
      </Maxdiv>
    </MainBack>
      <a href="https://www.instagram.com/stemon_kochi/">
      <InstScope className="rounded border">
          <p className="font-bold text-2xl"><span className="pl-3">Follow</span> Me<InstImg src={InstPng} alt="" /></p>
      </InstScope>
      </a>
    </>
  );
}